var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-bar',{attrs:{"width":300,"height":220,"axis-min":0,"axis-max":_vm.maxHeight,"labels":[ _vm.label ],"values":_vm.values,"colors":_vm.colors}},[_c('note',{attrs:{"text":'Bar Chart'}}),_c('tooltip',{attrs:{"names":[ _vm.label ],"position":'left'}}),_c('legends',{attrs:{"names":[ _vm.label ],"filter":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }